import api from "./api";

const panelUsersService = {
  list: () => api.get("/panel-users").then((r) => r.data),
  create: (payload) => api.post("/panel-users", payload).then((r) => r.data),
  setStatus: (id, is_active) => api.patch(`/panel-users/${id}/status`, { is_active }).then((r) => r.data),
  resetPassword: (id, password) => api.patch(`/panel-users/${id}/password`, { password }).then((r) => r.data),
};

export default panelUsersService;